import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, delay, switchMap } from 'rxjs/operators';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService,
              private router: Router) {
  }

  public addAuthHeader(request: HttpRequest<any>): any {
    const authHeader = this.authService.getAuthorizationHeader();
    if (!!authHeader) {
      const updatedReq = request.clone({
        headers: request.headers.set('Authorization', this.authService.getAuthorizationHeader())
      }) as HttpRequest<any>;

      // For debugging -
      // console.log(updatedReq);
      return updatedReq;
    }

    // No headers
    return request.clone();
  }

  public logout(): void {
    this.router.navigate(['public/logout']);
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    // Handle request
    request = this.addAuthHeader(request);

    // Handle response
    return next
      .handle(request)
      .pipe(
        catchError(error => {
          // Other statuses
          if (error.status !== 401) {
            return throwError(error);
          }

          // 401 error means the token is expired.
          return this.authService.refreshToken()
            .pipe(
              catchError((refreshErr) => {
                this.logout();
                return throwError(refreshErr);
              }),
              switchMap(() => {
                const retryRequest = this.addAuthHeader(request);
                // Delay is necessary so we don't request new token too many times on simult requests
                return next.handle(retryRequest).pipe(delay(1000));
              })
            );
        }), // -- End catch handler
      ); // -- End Pipe
  }
}
